const Lotties = {
  VENDOR_PERSON: "VENDOR_PERSON",
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
  ACCESS_DENIED: "ACCESS_DENIED",
};
export { Lotties };
